import React from "react";
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  TopToolbar,
} from "react-admin";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Actions = ({ onCancel }) => (
  <TopToolbar>
    <IconButton onClick={onCancel}>
      <CloseIcon />
    </IconButton>
  </TopToolbar>
);

const RiskLevelCreate = (props) => (
  <Create title=" " {...props} actions={<Actions {...props} />}>
    <SimpleForm redirect={props.basePath} variant="outlined">
      <TextInput source="name" fullWidth validate={required()} />
    </SimpleForm>
  </Create>
);

export default RiskLevelCreate;
